import { ActionContext } from "vuex"
import { ApiFn, RootState } from "../types"

export function createAsyncAction<TPayload, TResult, TStore>(
  apiFn: ApiFn<TPayload, TResult, TStore>,
  key: string
) {
  return async function (
    context: ActionContext<TStore, RootState>,
    payload: TPayload
  ): Promise<void> {
    context.commit("SET_ASYNC_STATE", {
      key,
      patch: { loading: true, error: null },
    })

    try {
      const result = await apiFn(context, payload)

      context.commit("SET_ASYNC_STATE", {
        key,
        patch: {
          loading: false,
          ...result,
        },
      })
    } catch (error) {
      context.commit("SET_ASYNC_STATE", {
        key,
        patch: { loading: false, error },
      })
    }
  }
}
